import { createAction } from 'redux-actions';
import { createAction as rtkCreateAction } from '@reduxjs/toolkit';

export const SERVER_RETURNED_PROPERTY_LIST =
  'DASHBOARD.SERVER_RETURNED_PROPERTY_LIST';
export const serverReturnedPropertyList = createAction(
  SERVER_RETURNED_PROPERTY_LIST
);

export const SET_COMPLAINTS_BY_PROPERTY =
  'DASHBOARD.SET_COMPLAINTS_BY_PROPERTY';
export const setComplaintsByProperty = createAction(SET_COMPLAINTS_BY_PROPERTY);

export const SET_ALL_OBSERVED_VIOLATION_TYPES =
  'DASHBOARD.ALL_OBSERVED_VIOLATION_TYPES';
export const setAllObservedViolationTypes = createAction(
  SET_ALL_OBSERVED_VIOLATION_TYPES
);

export const SET_ALL_OBSERVED_PLATFORMS =
  'DASHBOARD.SET_ALL_OBSERVED_PLATFORMS';
export const setAllObservedPlatforms = createAction(SET_ALL_OBSERVED_PLATFORMS);

export const SERVER_RETURNED_KPI_DATA = 'DASHBOARD.SERVER_RETURNED_KPI_DATA';
export const serverReturnedKpiData = createAction(SERVER_RETURNED_KPI_DATA);

export const SERVER_RETURNED_HOSTS_DATA =
  'DASHBOARD.SERVER_RETURNED_HOSTS_DATA';
export const serverReturnedHostsData = createAction(SERVER_RETURNED_HOSTS_DATA);

export const SERVER_RETURNED_OWNERS_DATA =
  'DASHBOARD.SERVER_RETURNED_OWNERS_DATA';
export const serverReturnedOwnersData = createAction(
  SERVER_RETURNED_OWNERS_DATA
);

export const SERVER_RETURNED_STATS_DATA =
  'DASHBOARD.SERVER_RETURNED_STATS_DATA';
export const serverReturnedStatsData = createAction(SERVER_RETURNED_STATS_DATA);

export const SERVER_RETURNED_RENTALSCAPE_CONFIG_DATA =
  'DASHBOARD.SERVER_RETURNED_RENTALSCAPE_CONFIG_DATA';
export const serverReturnedRentalscapeConfigData = createAction(
  SERVER_RETURNED_RENTALSCAPE_CONFIG_DATA
);

export const SERVER_RETURNED_TRANSLATIONS_DATA =
  'DASHBOARD.SERVER_RETURNED_TRANSLATIONS_DATA';
export const serverReturnedTranslationsData = createAction(
  SERVER_RETURNED_TRANSLATIONS_DATA
);

export const SET_HOA_DATA_ACTION = 'DATA.SET_HOA_DATA_ACTION';
export const setHoaDataAction = createAction(SET_HOA_DATA_ACTION);

export const FETCH_PROPERTY_DETAILS_DATA = 'DATA.FETCH_PROPERTY_DETAILS_DATA';
export const fetchPropertyDetailsData = createAction(
  FETCH_PROPERTY_DETAILS_DATA
);

export const SERVER_RETURNED_PROPERTY_DATA =
  'DATA.SERVER_RETURNED_PROPERTY_DATA';
export const serverReturnedPropertyData = createAction(
  SERVER_RETURNED_PROPERTY_DATA
);

export const SERVER_RETURNED_ACTIVITY_DATA =
  'DATA.SERVER_RETURNED_ACTIVITY_DATA';
export const serverReturnedActivityData = createAction(
  SERVER_RETURNED_ACTIVITY_DATA
);

export const SERVER_RETURNED_LICENSES_DATA =
  'DATA.SERVER_RETURNED_LICENSES_DATA';
export const serverReturnedLicensesData = createAction(
  SERVER_RETURNED_LICENSES_DATA
);

export const SERVER_RETURNED_TOT_PAYMENTS_DATA =
  'DATA.SERVER_RETURNED_TOT_PAYMENTS_DATA';
export const serverReturnedTOTPaymentsData = createAction(
  SERVER_RETURNED_TOT_PAYMENTS_DATA
);

export const SERVER_RETURNED_PROPERTY_COMPLAINTS_DATA =
  'DATA.SERVER_RETURNED_PROPERTY_COMPLAINTS_DATA';
export const serverReturnedPropertyComplaintsData = createAction(
  SERVER_RETURNED_PROPERTY_COMPLAINTS_DATA
);

export const UPDATE_SERVER_RETURNED_PROPERTY_COMPLAINTS_DATA =
  'DATA.UPDATE_SERVER_RETURNED_PROPERTY_COMPLAINTS_DATA';

export const updateServerReturnedPropertyComplaintsData = createAction(
  UPDATE_SERVER_RETURNED_PROPERTY_COMPLAINTS_DATA
);

export const USER_EDITED_NOTE = 'DATA.USER_EDITED_NOTE';
export const userEditedNote = createAction(USER_EDITED_NOTE);

export const UPDATE_NOTE = 'DATA.UPDATE_NOTE';
export const updateNote = createAction(UPDATE_NOTE);

export const USER_ADDED_NOTE = 'DATA.USER_ADDED_NOTE';
export const userAddedNote = createAction(USER_ADDED_NOTE);

export const ADD_NOTE = 'DATA.ADD_NOTE';
export const addNote = createAction(ADD_NOTE);

export const UPDATE_TEMP_NOTE = 'DATA.UPDATE_TEMP_NOTE';
export const updateTempNote = createAction(UPDATE_TEMP_NOTE);

export const SERVER_FAILED_TO_ADD_NOTE = 'DATA.SERVER_FAILED_TO_ADD_NOTE';
export const serverFailedToAddNote = createAction(SERVER_FAILED_TO_ADD_NOTE);

export const USER_UPDATE_LICENSE = 'DATA.USER_UPDATE_LICENSE';
export const userUpdateLicense = createAction(USER_UPDATE_LICENSE);

export const UPDATE_LICENSE = 'DATA.UPDATE_LICENSE';
export const updateLicense = createAction(UPDATE_LICENSE);

export const USER_UPDATE_LICENSE_STATUS = 'DATA.USER_UPDATE_LICENSE_STATUS';
export const userUpdateLicenseStatus = createAction(USER_UPDATE_LICENSE_STATUS);

export const USER_UPDATED_LICENSE_RENEWAL_STATUS =
  'DATA.USER_UPDATED_LICENSE_RENEWAL_STATUS';
export const userUpdatedLicenseRenewalStatus = createAction(
  USER_UPDATED_LICENSE_RENEWAL_STATUS
);

export const SERVER_RETURNED_UPDATED_LICENSE =
  'DATA.SERVER_RETURNED_UPDATED_LICENSE';
export const serverReturnedUpdatedLicense = createAction(
  SERVER_RETURNED_UPDATED_LICENSE
);

export const UPDATE_LICENSE_STATUS = 'DATA.UPDATE_LICENSE_STATUS';
export const updateLicenseStatus = createAction(UPDATE_LICENSE_STATUS);

export const UPDATE_LICENSE_RENEWAL_STATUS =
  'DATA.UPDATE_LICENSE_RENEWAL_STATUS';
export const updateLicenseRenewalStatus = createAction(
  UPDATE_LICENSE_RENEWAL_STATUS
);

export const SERVER_FAILED_TO_UPDATE_LICENSE_STATUS =
  'DATA.SERVER_FAILED_TO_UPDATE_LICENSE_STATUS';
export const serverFailedToUpdateLicenseStatus = createAction(
  SERVER_FAILED_TO_UPDATE_LICENSE_STATUS
);

export const SET_NOTE_ADD_STATUS = 'DATA.SET_NOTE_ADD_STATUS';
export const setNoteAddStatus = createAction(SET_NOTE_ADD_STATUS);
export const SERVER_SENT_LICENSE_TO_HOLDER =
  'DATA.SERVER_SENT_LICENSE_TO_HOLDER';
export const serverSentLicenseToHolder = createAction(
  SERVER_SENT_LICENSE_TO_HOLDER
);

export const USER_CLICKED_PROPERTY_DETAILS_TAB =
  'DATA.USER_CLICKED_PROPERTY_DETAILS_TAB';
export const userClickedPropertyDetailsTab = createAction(
  USER_CLICKED_PROPERTY_DETAILS_TAB
);

export const CLEAR_PROPERTY_DETAILS_DATA = 'DATA.CLEAR_PROPERTY_DETAILS_DATA';
export const clearPropertyDetailsData = rtkCreateAction(
  CLEAR_PROPERTY_DETAILS_DATA
);

export const SERVER_RETURNED_COMPLAINTS = 'DATA.SERVER_RETURNED_COMPLAINTS';
export const serverReturnedComplaints = createAction(
  SERVER_RETURNED_COMPLAINTS
);

export const FETCH_KPI_DATA = 'DATA.FETCH_KPI_DATA';
export const fetchKpiData = createAction(FETCH_KPI_DATA);

export const USER_UPDATE_COMPLAINT_STATUS = 'DATA.USER_UPDATE_COMPLAINT_STATUS';
export const userUpdateComplaintStatus = createAction(
  USER_UPDATE_COMPLAINT_STATUS
);

export const USER_UPDATE_COMPLAINT_STATUS_IN_PROPERTY_DETAILS =
  'DATA.USER_UPDATE_COMPLAINT_STATUS_IN_PROPERTY_DETAILS';
export const userUpdateComplaintStatusInPropertyDetails = createAction(
  USER_UPDATE_COMPLAINT_STATUS_IN_PROPERTY_DETAILS
);

export const UPDATE_COMPLAINT_STATUS = 'DATA.UPDATE_COMPLAINT_STATUS';
export const updateComplaintStatus = createAction(UPDATE_COMPLAINT_STATUS);

export const USER_VERIFIED_LISTING = 'DATA.USER_VERIFIED_LISTING';
export const userVerifiedListing = createAction(USER_VERIFIED_LISTING);
